// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const ImageIcon: React.FunctionComponent<any> = ({ stroke = "#585858", fill = "none", ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="none" d="M0 0h24v24H0V0z" />
                <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z" />
            </svg>
        </SvgIcon>
    );
};
